<template>
    <div class="cooperation">Une coopération <a href="https://lafourmiduweb.fr/" title="Rédactrice web" class="LinkText" target="_blank">La fourmi du web</a> &amp; <a href="https://net-gasoline.com/" title="Développeur javascript" class="LinkText" target="_blank">Net Gasoline</a></div>
</template>

<script>
    export default {
        name: "footerPage"
    }
</script>

<style>

</style>